import { Inquiryguide } from "./Inquiryguide";
import { TextDiv18Style } from "./InquiryText";
import { InquiryguideCenterBox250 } from "./InquiryguideBox";

export const InquiryguideFrame = () => {
  return (
    <InquiryguideCenterBox250>
      <Inquiryguide>
        <TextDiv18Style>문의 안내사항</TextDiv18Style>
      </Inquiryguide>
    </InquiryguideCenterBox250>
  );
};
